import type * as Sentry from '@sentry/react';

import { ErrorIndicator } from '@adflow/frontend/ui-graphics';
import { typography } from '@adflow/frontend/ui-theme';

type ErrorFallbackProps = Parameters<Sentry.FallbackRender>[0];

// TODO Make this usable in places things other than the root error boundary (sections, data grids, forms, etc...) so that we can isolate failures.
// TODO Translation support. (We need to be careful not to add something to this that could also cause a crash. Translations are known to cause crashes.)
function ErrorFallback({ error }: ErrorFallbackProps) {
	// When a chunk fails to load, we don't want to show an error screen.
	// The user will see a blank screen and the app will reload.
	if (error instanceof Error && error.name === 'ChunkLoadError') {
		return (
			<div
				css={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					width: '100%',
					height: '100%',
				}}
			/>
		);
	}

	return (
		<ErrorIndicator
			message={
				<div css={{ fontStyle: 'normal', fontWeight: '400' }}>
					<p>There was an unexpected problem.</p>
					<div>
						<button
							type="button"
							css={typography.clickableLink}
							onClick={() => {
								window.location.reload();
							}}
						>
							Try again
						</button>
					</div>
				</div>
			}
		/>
	);
}

// This needs to be a function that renders a component instead of just a component because of how Sentry.ErrorBoundary is implemented.
export const errorFallbackRender: Sentry.FallbackRender = (errorData) => (
	<ErrorFallback {...errorData} />
);
